/** Header / identifier helpers shared by inference, repairs and codegen. */

export function snakeCase(name: string, fallback = 'column'): string {
  const s = name
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[^A-Za-z0-9]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toLowerCase();
  if (s === '') return fallback;
  if (/^[0-9]/.test(s)) return `col_${s}`;
  return s;
}

export function camelCase(name: string): string {
  const parts = name
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .split(/[^A-Za-z0-9]+/)
    .filter(Boolean);
  if (parts.length === 0) return 'col';
  const head = parts[0].toLowerCase();
  const rest = parts.slice(1).map((p) => p[0].toUpperCase() + p.slice(1).toLowerCase());
  let ident = head + rest.join('');
  if (/^[0-9]/.test(ident)) ident = `col${ident}`;
  return ident;
}

export function pascalCase(name: string): string {
  const c = camelCase(name);
  return c.charAt(0).toUpperCase() + c.slice(1);
}

/** De-duplicate headers: blanks become column_N, repeats gain _2/_3 suffixes. */
export function dedupeHeaders(headers: string[]): string[] {
  const seen = new Map<string, number>();
  return headers.map((h, i) => {
    let name = h.trim() === '' ? `column_${i + 1}` : h;
    const n = seen.get(name) ?? 0;
    seen.set(name, n + 1);
    if (n > 0) name = `${name}_${n + 1}`;
    return name;
  });
}

/** Derive a table/model name from a file name: `orders-2024.csv` -> `orders_2024`. */
export function deriveTableName(fileName: string, fallback = 'dataset'): string {
  const base = fileName.split(/[\\/]/).pop() ?? fileName;
  const stem = base.replace(/\.[^.]+$/, '');
  const clean = snakeCase(stem, fallback);
  return clean || fallback;
}
